import script from "./CampoInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CampoInput.vue?vue&type=script&setup=true&lang=js"

import "./CampoInput.vue?vue&type=style&index=0&id=f9956dba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9956dba"]])

export default __exports__